import { Layout } from '@/components/layout/Layout';
import { LedgersPage } from './LedgersPage';

export function DebtsPage() {
    return (
        <Layout>
            <LedgersPage type="debt" />
        </Layout>
    );
}
